import DXFWriter from '@tarikjabiri/dxf';
import { Panel, Vertex2 } from '@rta/rta-blueprint-library';

import { addVectors } from './add-vector';
import { convertRect2Vectors } from '@r-core/helpers';
import { type RenderResult } from './types';

import { Layer, type Vector } from '@r-core/types';

type GeneratePanelVectorsParams = {
	drawing: DXFWriter;
	panel: Panel;
	xOffset: number;
	yOffset: number;
};

/**
 * Renders panel in front view (x, y coordinates)
 * Returns vectors and the width used
 */
export const generatePanelVectors = (params: GeneratePanelVectorsParams): RenderResult => {
	const { drawing, panel, xOffset, yOffset } = params;
	const panelWidth = panel.size.width;
	const panelHeight = panel.size.height;
	const labelX = xOffset - (panelWidth / 2);
	let vectors: Array<Vector<Vertex2>> = [];

	const panelVectors = convertRect2Vectors({
		center: { x: xOffset, y: yOffset },
		width: panelWidth,
		height: panelHeight,
		layer: Layer.Panel,
		metadata: {
			finishedEdge: false
		}
	});

	vectors = addVectors(panel.label, {
		vectors,
		newVectors: panelVectors
	});

	// Position label below panel (negate y to match DXF coordinate system)
	drawing.setCurrentLayer(Layer.Label);
	drawing.addText(labelX, -(yOffset + (panelHeight / 2) + 5), 3, panel.label);

	return { vectors, width: panelWidth, height: panelHeight, labelX };
};
